export const PRODUCTS_PER_PAGE = 6;
export const REVALIDATE_DATA_NONE = 0;
export const REVALIDATE_DATA = 600; //1 hour

export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://www.akrotect-baumaschinen.com"
    : "http://localhost:3000";

export const API = "https://akrotect-baumaschinen-data.onrender.com";
export const PRODUCTS_API = `${API}/products`;
export const ACCESSORIES_API = `${API}/accessories`;
export const OTHER_ACCESSORIES_API = `${API}/other_accessories`;
export const HOME_PRODUCTS_API = `${API}/home_products`;
export const SERVICES_API = `${API}/dienstleistungen`;
export const CONTACT_API = `${API}/contact`;
export const ACCESORY_API = `${API}/accessories/`; // + params.id
export const PRODUCT_API = `${API}/products/`; // + params.id
export const FILTERED_PRODUCTS_API = `${API}/products?`; // + FILTERED_QUERIES
export const FILTERED_ACCESSORIES_API = `${API}/accessories?`; // + FILTERED_QUERIES

export const FILTER_QUERIES = {
  pages: {
    page: "_page=",
    limit: "_limit=",
  },
  products: {
    category: "category_like=",
  },
  accessories: {
    category: "category_like=",
  },
  range: {
    min: "_price_gte=",
    max: "_price_lte=",
  },
};
